<!--工作室简介-->
<template>
    <div class="studio_nav_content">
        <div class="left-container">
            <div class="studio-img">
                <img class="studio-img-img" :src="studioInfo.groupAvatar" alt/>
            </div>
            <div class="info-item">
                {{studioInfo.groupNature==='2'?'名师':'名校长'}}：<span class="item-span">{{studioInfo.leadName}}</span>
            </div>
            <div class="info-item">
                学科：<span class="item-span">{{studioInfo.subjectName}}</span>
            </div>
            <div class="info-item">
                职称：<span class="item-span">{{studioInfo.teacherRankName}}</span>
            </div>
            <div class="info-item">
                设立单位：<span class="item-span">{{studioInfo.orgName}}</span>
            </div>
            <div class="apply-btn" @click="applyJoinStudio" v-if="studioInfo.isMember===0">
                申请加入工作室
            </div>
        </div>
        <div class="right-container">
            <div class="studio-top-name">
                {{studioInfo.groupName}}
            </div>
            <div class="studio-title">
                工作室简介
            </div>
            <div class="studio-intro">
                {{ studioInfo.groupIntroduce }}
            </div>
        </div>
    </div>
</template>

<script>
import {groupInfo} from "@/api/admin/system"
import {applyJoinGroup} from "@/api/admin/group"

export default {
    name:'briefIntroduction',
    components:{},
    props:{
        studioId:{
            type: String,
            default:null
        },
    },
    watch:{},
    mounted() {
        this.getStudioIntro()
    },
    data() {
        return {
            studioInfo:{},
        }
    },
    methods: {
        getStudioIntro(){
            groupInfo({ groupId: this.studioId }).then(res => {
                if (res.data.code === 1) {
                    this.studioInfo = res.data.data;
                }

            })
        },
        applyJoinStudio(){
            this.$confirm("您正在申请加入["+this.studioInfo.groupName+"]，是否继续？", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "success"
            }).then(() => {
                applyJoinGroup({ groupId: this.studioId }).then(res => {
                    if (res.data.code === 1) {
                        this.$message.success("申请已提交，请等待相关人员审核")
                    }else {
                        this.$message.error(res.data.msg)
                    }
                })
            }).catch(()=>{
            })

        },
    }
}

</script>

<style scoped>
.studio_nav_content{
    display: flex;
    width: 100%;
    height: auto;
}
.left-container{
    width: 240px;
    border-right: 1px solid #cecece!important;
    height: auto;
    background: #fff;
    padding-bottom: 20px;
    box-sizing: border-box;
}
.studio-img{
    width: 240px!important;
    height: 160px;
    padding-top: 30px!important;
    padding-left: 70px;
    box-sizing: border-box;

}
.studio-img-img{
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 1px solid #cecece;
}
.info-item{
    height: 20px;
    line-height: 20px;
    text-indent: 20px;
    font-size: 14px;
    color: #717171;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.item-span{
    color: #333333;
}
.apply-btn{
    height: 32px;
    width: 70%;
    line-height: 32px;
    cursor: pointer;
    text-align: center;
    font-size: 14px;
    color: #fff;
    background-color: #f65b2b;
    margin: auto;
    border-radius: 8px;
    margin-top: 20px;
}
.right-container{
    width: calc(100% - 240px);
    height: auto;
    background: #fff;
}
.studio-top-name{
    width: 100%;
    height: 60px;
    color: #f37f02;
    font-size: 20px;
    font-weight: 600;
    padding-top: 15px!important;
    text-indent: 10px;
}
.studio-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    color: #333333;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    font-family: "Segoe Print",serif
}
.studio-intro{
    width: 96%;
    height: auto;
    text-indent: 20px;
    color: #333333;
    font-size: 15px;
    margin: auto;
    font-family: "Segoe Print",serif
}
</style>